"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Yandex = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

var _SvgIcon = require("../SvgIcon");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var Yandex = function Yandex(props) {
  return /*#__PURE__*/React.createElement(_SvgIcon.SvgIcon, (0, _extends2.default)({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Yandex_svg__Yandex_svg__clip0_20336_109069)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.223 20.167c0-2.025-.678-3.89-1.813-5.388l1.207-.905a10.384 10.384 0 012.118 6.293c0 2.22-.692 4.273-1.89 5.966l-1.236-.865a8.781 8.781 0 001.614-5.101zm3.76-.054c0-2.563-.9-4.97-2.313-6.995l1.242-.857c1.557 2.233 2.583 4.934 2.583 7.852 0 2.817-.94 5.42-2.4 7.612l-1.26-.83c1.322-1.986 2.148-4.305 2.148-6.782z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.814 20.193a6.208 6.208 0 00-1.386-3.907l1.18-.94a7.707 7.707 0 01.296 9.311l-1.236-.867a6.21 6.21 0 001.146-3.597z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4.521,
    y: 10.909,
    width: 18.279,
    height: 18.182,
    rx: 9.091,
    fill: "#FC3F1D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.948 25.464h1.909V14.555H14.08c-2.793 0-4.261 1.429-4.261 3.532 0 1.68.805 2.668 2.24 3.689l-2.493 3.688h2.068l2.777-4.128-.963-.643c-1.167-.785-1.735-1.398-1.735-2.716 0-1.162.82-1.946 2.382-1.946h.853v9.433z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "Yandex_svg__Yandex_svg__clip0_20336_109069"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h40v40H0z"
  }))));
};

exports.Yandex = Yandex;
var _default = Yandex;
exports.default = _default;